<template>
    <Card>
        <Row :gutter="16">
            <Col span="24">
            <div class="global-tool-bar">
                <div class="left-bar">
                    <span class="title">个人中心</span>
                </div>
                <div class="right-bar" />
                <image-cut v-if="false"
                    v-model="imageTest" />
            </div>
            </Col>
        </Row>

        <Form label-position="top"
            class="small-form">

            <Row :gutter="16">
                <Col span="4">
                <FormItem :label="'登录账号' + getVerifyText()">
                    <Input :value="form.loginUserName"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="姓名">
                    <Input :value="form.personName"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="账号类型">
                    <Input :value="form.userType"></Input>
                </FormItem>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="4">
                <FormItem label="密码">
                    <Input v-model="password.password"
                        type="password"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="密码确认">
                    <Input v-model="password.passwordConfirm"
                        type="password"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label=" ">
                    <Button type="primary"
                        @click="onResetPassword">修改密码</Button>
                    <Button type="success"
                        class="btns"
                        :disabled="form.verifyStatus == '2'"
                        @click="onRealNameVerify">个人实名认证</Button>
                </FormItem>
                </Col>
            </Row>
        </Form>

    </Card>
</template>

<script>
import { getUserInfoByToken } from '@/api/modules/rbac';
import { resetPassword } from '@/api/user';
import ImageCut from '@/components/image-cut/ImageCut';
import { registerFddAccountForUser } from '@/api/modules/system-management/user-management';

export default {
    name: 'UserCenter',
    components: {
        ImageCut
    },
    data() {
        return {
            form: {
                loginUserName: '',
                userType: '',
                personName: '',
                verifyStatus: ''
            },
            password: {
                password: '',
                passwordConfirm: ''
            },
            imageTest: ''
        };
    },
    mounted() {
        this.getUserInfo();
    },
    methods: {
        getUserInfo() {
            this.$Spin.show();
            getUserInfoByToken().then(res => {
                this.$Spin.hide();
                if (res.code === 0) {
                    this.form = Object.assign(this.form, res.data.basicUserInfo);
                }
            }).catch(() => {
                this.$Spin.hide();
            });
        },
        getVerifyText() {
            if (this.form.verifyStatus == '2') {
                return '（已实名认证）';
            }
            else {
                return '（未实名认证）';
            }
        },
        onRealNameVerify() {
            this.$Spin.show();
            registerFddAccountForUser({}).then(res => {
                this.$Spin.hide();
                if (res.code === 0) {
                    let decode = atob(res.data.data.url);
                    let verifyUrl = decodeURI(decode);
                    window.open(verifyUrl, "_blank");
                }
            }).catch(() => {
                this.$Spin.hide();
            });
        },
        onResetPassword() {
            if (this.password.password === '') {
                this.$Modal.error({ title: '出错啦', content: '密码不能为空' });
                return;
            }

            if (this.password.password !== this.password.passwordConfirm) {
                this.$Modal.error({ title: '出错啦', content: '两次输入密码不一致' });
                return;
            }

            const data = this.password;
            this.$Spin.show();
            resetPassword(data).then(res => {
                this.$Spin.hide();
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '密码修改成功',
                        onOk: () => {

                        }
                    });
                }
            }).catch(() => {
                this.$Spin.hide();
            });
        }
    }
};
</script>

<style scoped>
</style>
